<template>
  <div class="question-wrap">
    <div class="question-detail" v-if="isQuestion">
      <div class="title">
        <span class="orange"></span>
        {{title}}
      </div>
      <div class="options">
        <div class="option" v-for="(item, index) in questionOptions" :key="item.id" @click.stop="check(index)" :class="{'option-checked':item.isChoose}">
          <div class="letter">{{letters[index]}}. </div>
          <div class="text">{{item.content}}</div>
        </div>
      </div>
      <div class="submit" @click="submit">提交答案</div>
    </div>
    <div class="answer-detail" v-else>
      <div class="title">
        <span class="orange"></span>
        {{title}}
      </div>
      <div class="options">
        <div class="option" v-for="(item, index) in questionOptions" :key="item.id" :class="{'option-checked':item.isChoose, 'option-error': !item.isAnswer, 'option-correct': item.isAnswer}">
          <div class="letter">{{letters[index]}}. </div>
          <div class="text">{{item.content}}</div>
          <img class="img" v-if="item.isAnswer" src="@/assets/svg/correct.svg">
          <img class="img" v-if="item.isChoose > 0 && !item.isAnswer" src="@/assets/svg/error.svg">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    questionOptions: {
      type: Array,
    },
    title: {
      type: String,
    },
  },
  data () {
    return {
      isQuestion: true,
      letters: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N'],
    }
  },
  methods: {
    check (index) {
      this.questionOptions.forEach(item => {
        if (item.isChoose) {
          item.isChoose = 0
        }
      })
      this.questionOptions[index].isChoose = this.questionOptions[index].id
    },
    submit () {
      for (let i = 0; i < this.questionOptions.length; i++) {
        if (this.questionOptions[i].isChoose) {
          this.$emit('submit', this.questionOptions[i].id, this.questionOptions[i].isAnswer)
          this.isQuestion = false
          return
        }
      }
      this.$Message.info('请选择答案', 'center')
    },
  },
}
</script>

<style lang="scss" scoped>
.question-wrap {
  width: 380px;
  height: 632px;
  background: #fff;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  border: 1px solid #d8d8d8;
  position: absolute;
  top: 0;
  right: -380px;
  z-index: 2;
}
    .question-detail, .answer-detail {
      padding: 30px 35px 0;
      height: 100%;
      background: #fff;
      border-radius: 6px 6px 0 0;
      overflow: auto;
      .title {
        font-family: PingFang SC;
        font-weight: 500;
        font-size: 18px;
        line-height: 25px;
        color: #212121;
        word-break: break-all;
        .orange {
          display: inline-block;
          background: #ed6c00;
          width: 2px;
          height: 16px;
        }
      }
      .options {
        .option:nth-child(1) {
          margin-top: 28px;
        }
        .option {
          cursor: pointer;
          position: relative;
          min-height: 46px;
          background: #F7F7F7;
          border-radius: 6px;
          display: flex;
          align-items: center;
          padding: 12px 42px 12px 20px;
          margin-top: 16px;
          color: #4A4A4A;
          .text {
            margin-left: 6px;
            word-break: break-all;
          }
        }
        .option-checked {
          background: #E2FBE9;
        }
        .option-checked.option-error {
          background: #FFEAEA;
        }
        .option-correct {
          background: #E2FBE9;
        }
        .img {
          position: absolute;
          right: 16px;
        }
      }
      .submit {
        cursor: pointer;
        width: 160px;
        height: 40px;
        left: 50%;
        transform: translate(50%);
        background: #ED6C00;
        border-radius: 48px;
        margin: 38px 0;
        color: #fff;
        line-height: 40px;
        text-align: center;
      }
    }
</style>
